import { render, staticRenderFns } from "./_base-validation-form.vue?vue&type=template&id=9e9b9fca&"
import script from "./_base-validation-form.vue?vue&type=script&lang=js&"
export * from "./_base-validation-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9e9b9fca')) {
      api.createRecord('9e9b9fca', component.options)
    } else {
      api.reload('9e9b9fca', component.options)
    }
    module.hot.accept("./_base-validation-form.vue?vue&type=template&id=9e9b9fca&", function () {
      api.rerender('9e9b9fca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_base-validation-form.vue"
export default component.exports